import * as R from 'ramda'
import { RSAA } from 'redux-api-middleware'
import { getApiPath } from 'sidecar-utility-library'

import { types, initialState } from './types'

export const getPaytientRedirectLink = authedUserUuid => ({
  [RSAA]: {
    endpoint: getApiPath(
      `exp`,
      `integration/paytient/member/${authedUserUuid}/signUpUrl`,
    ),
    method: 'GET',
    types: [
      types.FETCH_REDIRECT_REQUEST,
      types.FETCH_REDIRECT_SUCCESS,
      types.FETCH_REDIRECT_ERROR,
    ],
  },
})

export const getPaytientAccountStatus = authedUserUuid => ({
  [RSAA]: {
    endpoint: getApiPath(
      `exp`,
      `integration/paytient/member/${authedUserUuid}`,
    ),
    method: 'GET',
    types: [
      types.FETCH_STATUS_REQUEST,
      types.FETCH_STATUS_SUCCESS,
      types.FETCH_STATUS_ERROR,
    ],
  },
})

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    // Paytient Redirect Link
    case types.FETCH_REDIRECT_SUCCESS:
    // Paytient Account Status
    // eslint-disable-next-line no-fallthrough
    case types.FETCH_STATUS_SUCCESS: {
      return {
        ...state,
        paytient: {
          ...state.paytient,
          busy: false,
          entity: R.mergeDeepRight(state.paytient.entity, payload),
          error: '',
        },
      }
    }

    case types.FETCH_REDIRECT_REQUEST:
    case types.FETCH_STATUS_REQUEST: {
      return {
        ...state,
        paytient: {
          ...state.paytient,
          busy: true,
          error: '',
        },
      }
    }

    case types.FETCH_REDIRECT_ERROR:
    case types.FETCH_STATUS_ERROR: {
      return {
        ...state,
        paytient: {
          ...state.paytient,
          busy: false,
          error: R.pathOr(
            'There has been an error',
            ['response', 'message'],
            payload,
          ),
        },
      }
    }

    default:
      return state
  }
}
